<template>
  <div class="col s12 l6">
    <div class="page-subtitle">
      <h4>{{'Create' | localize}}</h4>
    </div>

    <form @submit.prevent="submitHandler">
      <div class="input-field">
        <select ref="select" v-model="category">
          <option
            v-for="category in categories"
            :key="category.id"
            :value="category.id"
          >{{category.title}}</option>
        </select>
        <label>{{'SelectCategory' | localize}}</label>
      </div>
      <router-link to="categories">{{'CreateCategory' | localize}}</router-link>

      <p>
        <label>
          <input class="with-gap" name="type" type="radio" value="income" v-model="type" />
          <span>{{'Income' | localize}}</span>
        </label>
      </p>

      <p>
        <label>
          <input class="with-gap" name="type" type="radio" value="outcome" v-model="type" />
          <span>{{'Outcome' | localize}}</span>
        </label>
      </p>

      <div class="input-field">
        <input
          id="amount"
          type="number"
          v-model.number="amount"
          :class="{invalid: ($v.amount.$dirty && !$v.amount.minValue) || ($v.amount.$dirty && !$v.amount.required)}"
        />
        <label for="amount">{{'Amount' | localize}}</label>
        <span
          v-if="$v.amount.$dirty && !$v.amount.required"
          class="helper-text invalid"
        >{{'EnterAmount' | localize}}</span>
        <span
          class="helper-text invalid"
          v-if="$v.amount.$dirty && !$v.amount.minValue"
        >{{'Message_MinLength' | localize}}: {{$v.amount.$params.minValue.min}}</span>
      </div>

      <div class="input-field">
        <input
          id="description"
          type="text"
          v-model.trim="description"
          :class="{invalid: $v.description.$dirty && !$v.description.required}"
        />
        <label for="description">{{'Description' | localize}}</label>
        <span
          v-if="$v.description.$dirty && !$v.description.required"
          class="helper-text invalid"
        >{{'Message_EnterDescription' | localize}}</span>
      </div>

      <button class="btn waves-effect waves-light" type="submit">
        {{'Create' | localize}}
        <i class="large material-icons right">create</i>
      </button>
    </form>
  </div>
</template>


<script>
import localizeFilter from "@/filters/localize.filter";
import { required, minValue } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "RecordCreate",
  props: ["categories"],
  data: () => ({
    select: null,
    amount: 100,
    description: "",
    category: null,
    type: "outcome"
  }),
  validations: {
    description: { required },
    amount: { required, minValue: minValue(100) }
  },
  async mounted() {
    if (this.categories.length) {
      this.category = this.categories[0].id;
    }

    await this.$nextTick(() => {
      this.select = M.FormSelect.init(this.$refs.select);
      window.M.updateTextFields();
    });
  },
  destroyed() {
    if (this.select && this.select.destroy) {
      this.select.destroy();
    }
  },
  computed: {
    ...mapGetters(["info"]),
    canCreateRecord() {
      if (this.type === "income") {
        return true;
      }

      return this.info.bill >= this.amount;
    }
  },
  methods: {
    async submitHandler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      if (this.canCreateRecord) {
        try {
          const record = {
            categoryId: this.category,
            amount: this.amount,
            description: this.description,
            type: this.type,
            date: new Date().toJSON()
          };
          await this.$store.dispatch("createRecord", record);

          const bill =
            this.type === "income"
              ? this.info.bill + this.amount
              : this.info.bill - this.amount;

          await this.$store.dispatch("updateInfo", { bill });
          this.$message(localizeFilter("RecordHasBeenCreated"));
          await this.$emit("created", record);
          this.$v.$reset();
          this.amount = 100;
          this.description = "";
        } catch (e) {}
      } else {
        this.$message(
          `${localizeFilter("NotEnoughMoney")}: (${this.amount -
            this.info.bill})`
        );
      }
    }
  }
};
</script>